import { useEffect, useState } from "react";
import api from "@/lib/api";

let cache = null;

export default function useSocialLinks() {
  const [links, setLinks] = useState(cache);
  useEffect(() => {
    if (cache) return;
    api.get("/social-links").then((r) => { cache = r.data; setLinks(r.data); }).catch(() => setLinks({}));
  }, []);
  return links;
}

export const bustSocialLinksCache = () => { cache = null; };
